import { Component, OnInit, ViewEncapsulation, Inject, Input, ViewChild } from '@angular/core';
import { HeaderUserDropdownComponent } from '@angular/synthrone-design/components';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderUserAppsComponent } from '@angular/synthrone-design/components';
import { SynthroneDataService } from '@synthroneApp/services/synthrone-data/synthrone-data.service';
import { AuthenticateService, CommonFunctionsService, CookieService } from '@angular/synthrone-design/services';



@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppLayoutComponent implements OnInit {

  @Input('getMenuFn') getMenuFn:Function

  constructor(
    @Inject(SynthroneDataService) public SynthroneDS,
    private activatedRoute: ActivatedRoute, 
    @Inject(AuthenticateService) public authenticateService,
    private router: Router, 
    @Inject(CommonFunctionsService) public commonService,
    private cookieService: CookieService) { }

  timeLeft: number;
  userTimeZone: string = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
  interval;

  ngOnInit() {
    this.getMenuFn = this.getMenuFn || this.SynthroneDS.sdGetMenu;
    this.timeLeft = this.getTokenTimeLeft();
    this.startTimer();
  }

  startTimer = () => {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft = this.timeLeft - 1;
      }
    },1000)
  }

  getTokenTimeLeft = () => {
     const systemToken = this.cookieService.getCookie('systemToken', false, true);
     if (systemToken) {
       const tokenData = JSON.parse(window.atob(systemToken.split('.')[0]));
       return Math.max(0, Math.trunc((tokenData['stt'] * 1000 - +new Date) / 1000));
     }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-layout/app-layout.component.ts